import { render } from "./callsNumber.vue?vue&type=template&id=4181eb08&scoped=true"
import script from "./callsNumber.vue?vue&type=script&lang=js"
export * from "./callsNumber.vue?vue&type=script&lang=js"

import "./callsNumber.vue?vue&type=style&index=0&id=4181eb08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4181eb08"

export default script